<template>
  <section class="partners section" id="partners">
    <div class="wrapper">
      <h1 class="title">Parcerias Estratégicas</h1>
      <div class="logo-list row center-xs middle-xs">
        <div class="col-md-3 col-sm-3 col-xs-12 item"
        :key="index"
        v-for="(parceiro, index) in api.parceiros">
          <img :src="parceiro.logo" alt="">
        </div>
      </div>
      <p class="text">{{api.partners_text}}</p>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ParceriasEstratégicas',
  props: ['api'],
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus">
  #partners
    padding 100px 0
    img
      max-width 100%
    .title
      display block
      &:after
        content ''
        height 1px
        width 600px
        max-width 100%
        background #E5E5E5
        display block
        margin 85px auto -10px
    .logo-list
      &:after
        content ''
        height 1px
        display block
        width 80%
        background #E5E5E5
        margin 45px auto
    @media (max-width 940px)
      .item
        margin-bottom 80px
        &:last-child
          margin-bottom 0
</style>



// WEBPACK FOOTER //
// src/components/PartnersSection.vue